import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/app/model/store';

import { albumAdapter } from './albumSlice.ts';

export const { selectAll, selectById } = albumAdapter.getSelectors(
  (state: RootState) => state.album,
);

export const selectAllPhotos = createSelector(selectAll, (albums) =>
  albums.flatMap((album) => album.StudyAssetIDs),
);

export const selectLoading = (state: RootState) => state.album.loading;

export const selectAlbumsWithAssets = createSelector(selectAll, (albums) =>
  albums.filter(({ StudyAssetIDs }) => StudyAssetIDs.length),
);

export const hasDentalPhotos = createSelector(selectAll, (albums) =>
  albums.some(({ StudyAssetIDs }) => StudyAssetIDs.length),
);

export const selectPhotoTransform = (state: RootState, photoID: string) =>
  state.album.photoTransforms[photoID];
